import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=ef93a5c8&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ploi/www.continental-holdings.com/web/app/themes/chc-wp-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef93a5c8')) {
      api.createRecord('ef93a5c8', component.options)
    } else {
      api.reload('ef93a5c8', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=ef93a5c8&", function () {
      api.rerender('ef93a5c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/components/Tabs.vue"
export default component.exports